/** The built-in admin panel lives under /admin-panel (core CLAUDE.md). */
export const ADMIN_BASE = '/admin-panel';

export function isAdminRoute(pathname: string): boolean {
  return pathname === ADMIN_BASE || pathname.startsWith(`${ADMIN_BASE}/`);
}
